import styled from 'styled-components'

import { pillarBox1920Styles } from '../../../lib/styles/pillar-box'

export const Background = styled.div`
  background: ${({ theme }) => theme.colors.coolGray.cool100};
  padding-left: 15%;
  padding-right: 15%;
  @media (min-width: 992px) {
    padding-left: 128px;
    padding-right: 128px;
  }
  @media (min-width: 1440px) {
    padding-left: 192px;
    padding-right: 192px;
  }
`
export const ScrollableContainer = styled.div`
  display: flex;
  overflow-x: auto;
  width: 100%;
  gap: 20px;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`

export const Container = styled.div`
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  overflow: visible;
  width: 100%;
  padding-bottom: 20px;
  ${pillarBox1920Styles};
`

export const Title = styled.h1`
  font-size: 28px;
  padding-top: 2rem;
  @media (min-width: 992px) {
    margin-left: 0;
    margin-right: 0;
  }
  @media (min-width: 1440px) {
    font-size: 32px;
  }
`

export const Subtitle = styled.p`
  font-size: 18px;
  margin-top: 0.5rem;
  @media (min-width: 992px) {
    margin-left: 0;
    margin-right: 0;
  }
  @media (min-width: 1440px) {
    font-size: 16px;
  }
`
